<template>
  <div>
    <custom-actions>
      <template #header>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item prop="userId" label="客户名称">
          <el-select v-model="searchForm.userId" clearable placeholder="请选择客户名称">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="specId" label="品种规格">
          <el-select v-model="searchForm.specId" clearable placeholder="请选择品种规格">
            <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联油罐" prop="ygId">
          <el-select v-model="searchForm.ygId" clearable placeholder="请选择关联油罐">
            <el-option v-for="(item, index) of ygList" :value="item.ygId" :label="item.ygCode" :key="index"></el-option>
          </el-select> </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="客户名称" prop="userName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="品种规格" prop="specName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="关联油罐" prop="ygCode"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="客户存油量" prop="quantity"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/customerOilStorage/detail?storageId=' + row.storageId)">详情</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CustomerOilStorage',

  data () {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        ygId: null,
        specId: null,
        userId: null
      },

      ygList: [],
      userList: [],
      specList: []
    }
  },
  created () {
    this.loadDict()
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.customerOilStorage.selectYgnCustStorageByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    loadDict () {
      // 油罐
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
        this.ygList = res.list || []
      })

      // 用户
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2'

      }).then(res => {
        this.userList = res.list || []
      })

      // 规格
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.specList = res.list || []
        })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        ygId: null,
        specId: null,
        userId: null
      }
      this.onSearch()
    }

  }
}
</script>

<style scoped lang='scss'></style>
